module.exports = __webpack_public_path__ + "img/logo_m.b784e7aa.png";